export enum ProjectChecklistProfileTab {
  Overview,
  Settings,
  Columns,
  Rows,
  Activity,
  Delete
}
